import { render } from "./GetParentDevice.vue?vue&type=template&id=df47d480&ts=true"
import script from "./GetParentDevice.vue?vue&type=script&lang=ts"
export * from "./GetParentDevice.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__